import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function Cuadro1EncuestaUsuario({ idSolicitud }) {
  const { idSolicitud: idSolicitudParam } = useParams();
  const solicitud = idSolicitud || idSolicitudParam;

  const [list, setList] = useState(0);
  const [list1, setList1] = useState([]);

  useEffect(() => {
    if (!solicitud) return;

    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerConteoEvaluaciones/1/${solicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((response) => setList(response.data || 0))
      .catch((error) => console.error("Error obteniendo conteo:", error));
  }, [solicitud]);

  useEffect(() => {
    if (!solicitud) return;

    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerResultados/1/${solicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((response) => setList1(response.data || []))
      .catch((error) => console.error("Error obteniendo resultados:", error));
  }, [solicitud]);

  const filtroCalificacion = useMemo(
    () => list1.filter((e) => e.tipoRespuesta === "Calificacion"),
    [list1],
  );

  const filtroSeleccion = useMemo(
    () => list1.filter((e) => e.tipoRespuesta === "Seleccion"),
    [list1],
  );

  const safeDivide = (valor) => {
    if (!list || list === 0) return 0;
    return ((valor / list) * 100).toFixed(0);
  };

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Información Encuestas
          </h6>
          Encuestas realizadas: <strong>{list}</strong>
        </div>

        {/* ================= TABLA SELECCIÓN ================= */}
        <table className="table table-bordered" width="100%" cellSpacing="0">
          <thead>
            <tr>
              <th>Variable</th>
              <th>Si</th>
              <th>Si %</th>
              <th>No</th>
              <th>No %</th>
              <th>No Aplica</th>
              <th>No Aplica %</th>
            </tr>
          </thead>

          <tbody>
            {filtroSeleccion.map((item, index) => (
              <tr key={index}>
                <td className="text-justify">{item.pregunta}</td>
                <td>{item.afirmativo}</td>
                <td>{safeDivide(item.afirmativo)}%</td>
                <td>{item.negativo}</td>
                <td>{safeDivide(item.negativo)}%</td>
                <td>{item.noAplica}</td>
                <td>{safeDivide(item.noAplica)}%</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ================= TABLA CALIFICACIÓN ================= */}
        <table className="table table-bordered" width="100%" cellSpacing="0">
          <thead>
            <tr>
              <th>Variable</th>
              <th>Muy mala</th>
              <th>Mala</th>
              <th>Regular</th>
              <th>Buena</th>
              <th>Muy Buena</th>
              <th>Excelente</th>
              <th>NA</th>
              <th>Total %</th>
            </tr>
          </thead>

          <tbody>
            {filtroCalificacion.map((item, index) => {
              const total =
                item.muyMala +
                item.mala +
                item.regular +
                item.buena +
                item.muyBuena +
                item.excelente;

              const totalPorcentaje = safeDivide(total);

              return (
                <tr key={index}>
                  <td className="text-justify">{item.pregunta}</td>
                  <td>{item.muyMala}</td>
                  <td>{item.mala}</td>
                  <td>{item.regular}</td>
                  <td>{item.buena}</td>
                  <td>{item.muyBuena}</td>
                  <td>{item.excelente}</td>
                  <td>{item.na}</td>
                  <td>{totalPorcentaje}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Cuadro1EncuestaUsuario;
